import { StyledComponentPropsWithRef } from "styled-components";
import { TBadgeProps } from "../Badge";
import Flex, { FlexProps } from "../Flex";

export interface IActiveFacet<TFacetName extends string> {
    name: TFacetName | "all";
    value: number | string | undefined;
}
export interface IFacetsProps<TFacetName extends string, TQueryName extends string = string>
    extends FlexProps,
        Omit<StyledComponentPropsWithRef<typeof Flex>, "color" | "onChange" | "ref"> {
    query?: TQueryName;
    all?: boolean;
    allLabel?: string;
    defaultSelection?: TFacetName;
    names: readonly TFacetName[];
    disabledNames?: readonly TFacetName[];
    values?: TFacetsValues<TFacetName>;
    getLabel?: (name: TFacetName) => string;
    getBadgeProps?: (name: TFacetName) => Omit<TBadgeProps, "text">;
    trackName?: string;
    trackData?: object;
    ignoreFilters?: string[];
    keepFiltersOnSelect?: boolean;
    onChange?: (activeFacet: IActiveFacet<TFacetName> | undefined) => void;
}

export type TFacetsValues<TFacetName extends string> = Partial<Record<TFacetName, number | string>>;
